/**
 * `event.target` and `event.currentTarget` are typed as EventTarget, which
 * carries no DOM API, and can be a text node or null. These narrow to the
 * element a handler expects, or to undefined when the event came from
 * somewhere else.
 */
export const targetElementOf = <E extends Element>(
  target: EventTarget | null,
  // The constructor is only used with instanceof, so its arguments never matter.
  constructor: abstract new (...args: never[]) => E,
): E | undefined => (target instanceof constructor ? target : undefined);

/**
 * Element, not HTMLElement: a click on an icon lands on the `<svg>` or a
 * `<path>` inside it, and narrowing those away would make the handler skip the
 * very click it exists for.
 */
export const targetElement = (
  target: EventTarget | null,
): Element | undefined => targetElementOf(target, Element);

// For handlers that read `dataset`, which Element does not carry.
export const targetHtmlOrSvgElement = (
  target: EventTarget | null,
): HTMLElement | SVGElement | undefined =>
  target instanceof HTMLElement || target instanceof SVGElement
    ? target
    : undefined;
